export const unbanUser = async (
    feedName: string,
    email: string,
    userId: string,
    token: string
) => {
    const body = {
        email: email,
        feed_name: feedName,
        users_id: userId,
        country: 'MX'
    }
    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_ADMINISTRATION_XAPIKEY
        },
        body: JSON.stringify(body),
    };
    const urlRequest = `${process.env.REACT_APP_ADMINISTRATION_API_URL}banned_users`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

